import type { VariantProps } from "tailwind-variants";

import { iconStyles } from "./styles";

type IconProps = React.ComponentProps<"svg"> & VariantProps<typeof iconStyles>;

function IconSvg({ color, className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={24}
      width={24}
      {...props}
      className={iconStyles({ color, className })}
    />
  );
}

function StatusCancelledIcon(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path
        d="M12 24A12 12 0 1 0 0 12a12 12 0 0 0 12 12ZM7.05 8.46a1 1 0 0 1 1.41 -1.41l3.36 3.36a0.25 0.25 0 0 0 0.36 0l3.36 -3.36A1 1 0 0 1 17 8.46l-3.36 3.36a0.25 0.25 0 0 0 0 0.36L17 15.54A1 1 0 0 1 17 17a1 1 0 0 1 -0.71 0.29 1 1 0 0 1 -0.7 -0.29l-3.36 -3.36a0.25 0.25 0 0 0 -0.36 0L8.46 17a1 1 0 0 1 -0.7 0.29 1 1 0 0 1 -0.71 -0.29 1 1 0 0 1 0 -1.41l3.36 -3.36a0.25 0.25 0 0 0 0 -0.36Z"
        fill="currentcolor"
        strokeWidth={1}
      />
    </IconSvg>
  );
}

function StatusCompleteIcon(props: IconProps) {
  return (
    <IconSvg {...props}>
      <g>
        <path
          d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 22a10 10 0 1 1 10 -10 10 10 0 0 1 -10 10Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M12 4a0.5 0.5 0 0 0 -0.5 0.5v7h-7a0.5 0.5 0 0 0 -0.5 0.5 8 8 0 1 0 8 -8Z"
          fill="currentcolor"
          strokeWidth={1}
        />
      </g>
    </IconSvg>
  );
}

function StatusFinalIcon(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path
        d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm6.93 8.2 -6.85 9.29a1 1 0 0 1 -1.43 0.19l-4.89 -3.91a1 1 0 0 1 -0.15 -1.41A1 1 0 0 1 7 12.21l4.08 3.26L17.32 7a1 1 0 0 1 1.39 -0.21 1 1 0 0 1 0.22 1.41Z"
        fill="currentcolor"
        strokeWidth={1}
      />
    </IconSvg>
  );
}

function StatusFullIcon(props: IconProps) {
  return (
    <IconSvg {...props}>
      <g>
        <path
          d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 22a10 10 0 1 1 10 -10 10 10 0 0 1 -10 10Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M4 12a8 8 0 1 0 16 0 8 8 0 1 0 -16 0"
          fill="currentcolor"
          strokeWidth={1}
        />
      </g>
    </IconSvg>
  );
}

function StatusInProgressIcon(props: IconProps) {
  return (
    <IconSvg {...props}>
      <g>
        <path
          d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 22a10 10 0 1 1 10 -10 10 10 0 0 1 -10 10Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M12 4a0.5 0.5 0 0 0 -0.5 0.5v15a0.5 0.5 0 0 0 0.5 0.5 8 8 0 0 0 0 -16Z"
          fill="currentcolor"
          strokeWidth={1}
        />
      </g>
    </IconSvg>
  );
}

function StatusNewIcon(props: IconProps) {
  return (
    <IconSvg {...props}>
      <g>
        <path
          d="M21.34 8.44a1 1 0 0 0 1.3 0.58 1 1 0 0 0 0.57 -1.29 12 12 0 0 0 -0.88 -1.84A1 1 0 0 0 21 5.53a1 1 0 0 0 -0.35 1.37 10.84 10.84 0 0 1 0.69 1.54Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M19.58 2.69a12 12 0 0 0 -1.69 -1.15 1 1 0 0 0 -1.36 0.38 1 1 0 0 0 0.38 1.36 10.21 10.21 0 0 1 1.4 1 1 1 0 1 0 1.27 -1.55Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M11.88 2a9.66 9.66 0 0 1 1.7 0.12 1 1 0 0 0 1.15 -0.82 1 1 0 0 0 -0.82 -1.15 11.61 11.61 0 0 0 -2 -0.15 1 1 0 0 0 0 2Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M6.91 3.39a10.28 10.28 0 0 1 1.53 -0.74A1 1 0 0 0 9 1.36 1 1 0 0 0 7.73 0.78a13 13 0 0 0 -1.84 0.89 1 1 0 1 0 1 1.72Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M1.92 7.47a1 1 0 0 0 1.37 -0.38 9.57 9.57 0 0 1 1 -1.4 1 1 0 0 0 -1.6 -1.27 12.9 12.9 0 0 0 -1.15 1.69 1 1 0 0 0 0.38 1.36Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M1 13.12a1 1 0 0 0 1 -1 9.66 9.66 0 0 1 0.13 -1.7 1 1 0 0 0 -0.83 -1.16 1 1 0 0 0 -1.15 0.83 11.61 11.61 0 0 0 -0.15 2 1 1 0 0 0 1 1Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M2.66 15.56a1 1 0 1 0 -1.87 0.71 12.43 12.43 0 0 0 0.88 1.84 1 1 0 0 0 1.33 0.35 1 1 0 0 0 0.35 -1.37 10.73 10.73 0 0 1 -0.69 -1.53Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M7.09 20.71a10.21 10.21 0 0 1 -1.4 -1 1 1 0 0 0 -1.27 1.59 12 12 0 0 0 1.69 1.15 1 1 0 0 0 1 -1.74Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M12.12 22a9.66 9.66 0 0 1 -1.7 -0.13 1 1 0 0 0 -1.15 0.83 1 1 0 0 0 0.83 1.15A12.2 12.2 0 0 0 12 24a1 1 0 0 0 1.12 -1 1 1 0 0 0 -1 -1Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M17.09 20.6a9.39 9.39 0 0 1 -1.53 0.74 1 1 0 0 0 -0.56 1.29 1 1 0 0 0 1.29 0.58 11.15 11.15 0 0 0 1.84 -0.89 1 1 0 0 0 0.33 -1.32 1 1 0 0 0 -1.37 -0.4Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M22.08 16.52a1 1 0 0 0 -1.37 0.38 9.67 9.67 0 0 1 -0.95 1.41 1 1 0 1 0 1.55 1.26 11.69 11.69 0 0 0 1.15 -1.69 1 1 0 0 0 -0.38 -1.36Z"
          fill="currentcolor"
          strokeWidth={1}
        />
        <path
          d="M23 10.88a1 1 0 0 0 -1 1 9.66 9.66 0 0 1 -0.13 1.7 1 1 0 0 0 2 0.32 11.68 11.68 0 0 0 0.15 -2A1 1 0 0 0 23 10.88Z"
          fill="currentcolor"
          strokeWidth={1}
        />
      </g>
    </IconSvg>
  );
}

function StatusQuarterIcon(props: IconProps) {
  return (
    <IconSvg {...props}>
      <g>
        <path
          d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 22a10 10 0 1 1 10 -10 10 10 0 0 1 -10 10Z"
          fill="#000000"
          strokeWidth={1}
        />
        <path
          d="M12 4a0.5 0.5 0 0 0 -0.5 0.5v8a0.5 0.5 0 0 0 0.5 0.5h7.47a0.59 0.59 0 0 0 0.51 -0.55A8 8 0 0 0 12 4Z"
          fill="#000000"
          strokeWidth={1}
        />
      </g>
    </IconSvg>
  );
}

function StatusReceivedIcon(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path
        d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 22a10 10 0 1 1 10 -10 10 10 0 0 1 -10 10Z"
        fill="currentcolor"
        strokeWidth={1}
      />
    </IconSvg>
  );
}

export {
  StatusCancelledIcon,
  StatusCompleteIcon,
  StatusFinalIcon,
  StatusFullIcon,
  StatusInProgressIcon,
  StatusNewIcon,
  StatusQuarterIcon,
  StatusReceivedIcon,
};
